import styled from "styled-components";

const HeaderContainer = styled.div`
  border-bottom: 1px solid rgb(33, 175, 196);
  .HeaderContent {
    font-family: "Do Hyeon", sans-serif;
    width: 50%;
    justify-content: center;
    display: flex;
    margin: 1rem auto;
    a {
      cursor: pointer;
      width: 30%;
      margin: auto 0;
      margin-right: auto;
      &:hover {
        color: rgb(1, 165, 188);
      }
    }
    img {
      width: 100%;
      margin-top: 0.5em;
    }
  }
  .HeaderContentLink {
    line-height: 4rem;
    span {
      padding: 1rem;
    }
    a {
      text-decoration: none;
      color: black;
      font-size: 1.2rem;
    }
  }
  @media only screen and (max-width: 480px) {
    .HeaderContent {
      margin: 0;
      display: block;
      width: 100%;
      a {
        width: 100%;
        margin: 0;
      }
      img {
        width: 80%;
        height: auto;
      }
    }
    .HeaderContentLink {
      width: 100%;
      span {
        padding: 0 0.4em;
      }
      a {
        font-size: 1.2rem;
      }
    }
  }
`;

const HeaderTopContainer = styled.div`
  width: 100%;
  font-size: 0.8rem;
  background-color: #333;
  color: white;
  line-height: 1.5rem;
  .Content {
    width: 50%;
    margin: 0 auto;
    text-align: right;
  }
  .Content a {
    color: white;
    margin: 0 1%;
    text-decoration: none;
  }
  img {
    width: 2%;
    vertical-align: middle;
    margin-bottom: 0.5%;
  }
  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

const HeaderCss = {
  HeaderContainer,
  HeaderTopContainer
};

export default HeaderCss;
